const { gql } = require('@apollo/client');

export const PAGE_FILTER_SALES_STOCK = gql`
  query {
    PageFilterSalesStock {
      timePeriod {
        name
        value
      }
      fleetIndicators {
        name
        value
      }
      modelYears {
        name
        value
      }
      carTruckCodes {
        name
        value
      }
      drivetrainNames {
        name
        value
      }

      exteriorColorDescriptions {
        name
        value
      }

      interiorColorDescriptions {
        name
        value
      }
      distributorCodes {
        distributorCode
        distributorName
        brandCodes {
          brandCode
          brandName
          regions {
            regionCode
            regionName
            dealers {
              dealerCode
              dealerName
              vehicleAssignmentIndicator
            }
          }
          accessoriesFactories {
            code
            value
          }
          accessoriesPostProductions {
            code
            value
          }
          salesSeriesNames {
            code
            value
          }
        }
      }
    }
  }
`;
